export const PERSON_TITLES = ['Dr', 'Miss', 'Mr', 'Mrs', 'Prof', 'Sr', 'Mst', 'Ms'];